module.exports = __webpack_public_path__ + "img/logo-circle.e24ecf25.png";